import React from "react";
import PopUp, { closePopUp } from "../../components/popUp";
import Button from "../../components/button";

interface ConfirmDeletePiecePopUpProps {
    onDelete: () => Promise<void>;
}

export default function ChangeEmailPage(props: ConfirmDeletePiecePopUpProps) {

    const [loading, setLoading] = React.useState(false);
    return <PopUp title="Delete Piece">
        <p>Are you sure, you want to delete this piece?</p>
        <div className="buttons">
            <Button loading={loading} onClick={async function() {
                setLoading(true);
                await props.onDelete();
                setLoading(false);
                closePopUp();
            }}>Delete</Button>
            <Button onClick={closePopUp}>Cancel</Button>
        </div>
    </PopUp>
}